<script setup lang="ts">
interface Props {
  data: object | string | number
  cellConfig: Object,
}

const props = defineProps<Props>()
</script>

<template>
  <div class="table-cell commission-user-cell">
    <template v-if="props.data?.id">
      <h4 class="whitespace-nowrap">{{props.data?.full_name}}</h4>
      <p>{{props.data?.phone_number}}</p>
    </template>
    <template v-else>
      <h4>Quỹ & Bộ phận hỗ trợ</h4>
    </template>
  </div>
</template>

<style scoped>
.commission-user-cell{
  display: flex;
  flex-direction: column;
  h4{
    font-weight: 500;
  }
  p{
    font-size: 12px;
    color: #b3b3b3;
  }
}
</style>
